import { AnalyticsLayer } from '@opallabs/quanta'
import { kuiperClassNames } from '../../utils'
import Input from '../Input'
import './styles.scss'

export default class Currency extends Input {
  static defaultProps = {
    ...Input.defaultProps,
    isCurrency: true,
    displayCurrencySymbol: true,
  }

  onChange(e) {
    let value = e.target.value
    if (value !== this.props.value) {
      value = value.replace(/\D/g, '').substring(0, 9)
    }
    this.props.onChange(value, this.props.name)
  }

  get currencySymbol() {
    if (this.props.displayCurrencySymbol) {
      return <span className={kuiperClassNames('currency-symbol')}>$</span>
    }
    return null
  }

  get input() {
    return (
      /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
      <AnalyticsLayer name="Currency Input">
        <div
          className={kuiperClassNames('input-container')}
          onClick={this.inputFocus}
        >
          {this.icon}
          {this.currencySymbol}
          {this.inputElement}
          {this.aside}
        </div>
      </AnalyticsLayer>
    )
  }
}
